import { Injectable, NgZone } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { GlobalConfig, ToastrService } from 'ngx-toastr';
import { ToastNotificationComponent } from 'src/app/shared/toast-notification/toast-notification.component';
import { ToastInput } from './toast-notification';
import { NativeCheckService } from '../native-check.service';

@Injectable({
  providedIn: 'root'
})
export class ToastNotificationService {
  private defaultOptions = JSON.parse(JSON.stringify(this.toastr.toastrConfig));

  public constructor(
    private toastr: ToastrService,
    private zone: NgZone,
    private nativeCheckService: NativeCheckService,
  ) { }

  public addNotification(toastInput: ToastInput): void {

    const options: Partial<GlobalConfig> = {
      ...this.defaultOptions,
      toastComponent: toastInput.component,
      preventDuplicates: true,
    }

    if(toastInput.disableAutohide) {
      options.disableTimeOut = true;
    }

    if(toastInput.extendTimeout) {
      options.timeOut = 30000;
    }

    if(toastInput.payload) {
      options.payload = toastInput.payload;
    }

    if(Capacitor.getPlatform() === 'ios') {
      options.positionClass = 'toaster-ios-safezone-position';
    }

    // on Capacitor toasts were not displaying/hiding correctly
    if(this.nativeCheckService.isNativePlatform()) {
      this.zone.run(() => {
        this.toastr.show(toastInput.message, toastInput.title, options, toastInput.type);
      });
    } else {
      this.toastr.show(toastInput.message, toastInput.title, options, toastInput.type);
    }
  }

  public unknownApiError(): void {
    this.addNotification({
      title: 'toastNotifications.headers.apiCallError',
      message: 'toastNotifications.messages.apiCallError',
      type: 'warning',
      component: ToastNotificationComponent,
    });
  }
}
